import {DetailTable} from '../../mapping-classes/detail-table';

export class Commission implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(commission: any) {
    if (!commission || !commission.basicTableData || commission.basicTableData.length === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = commission.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(commission.basicTableData);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen provisie afspraken.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'type',
      'percentage',
    ];
  }

  setRowData(costs) {
    costs.forEach((cost) => {
      if (this.restrictedData) {
        cost.percentage = this.shieldedText;
      }
      this.rowData.push(cost);
    });
  }
}
